

import { GetITileInformationDataByInstitutionIdAndTrialId, GetITileInformationDataByInstitutionIdAndTrialIdResponse } from '@/api/dtos';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import usePost from '../api/usePost';

const getData = (response?: SWRResponse<GetITileInformationDataByInstitutionIdAndTrialIdResponse, GetITileInformationDataByInstitutionIdAndTrialIdResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetITileInformationDataByInstitutionIdAndTrialIdResponse, GetITileInformationDataByInstitutionIdAndTrialIdResponse>) => (response?.error ?? response?.data)?.responseStatus;


export const useInformationData = (trialId?: number, institutionId?: string, apiLinks?: string[] ,configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId || !apiLinks) {
            return undefined;
        }

        return () => {
            return new GetITileInformationDataByInstitutionIdAndTrialId({ 
                trialId, 
                institutionId, 
                apiLinksUnconfigured: apiLinks
            });
        }
    }, [trialId, institutionId, apiLinks]);

    return usePost(request, { getData, getError }, configuration);
}

export default useInformationData;